import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, TrendingDown } from "lucide-react";
import Navbar from "../../components/Navbar";
import { mk, money } from "../../lib/market";
import { EmailGate } from "../../components/market/EmailGate";
import { CartButton } from "../../components/market/CartButton";
import { ListingCard } from "../../components/market/ListingCard";
import { useMarketMe } from "./MarketHome";

export default function MarketSaved() {
  const [me, reloadMe] = useMarketMe();
  const [rows, setRows] = useState(null);
  useEffect(() => { if (me) mk.get("/market/saved").then((r) => setRows(r.data)).catch(() => setRows([])); }, [me]);
  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <Navbar />
      <div className="container-wide px-5 md:px-12 pt-28 pb-20">
        <div className="flex items-center justify-between mb-4"><Link to="/market" className="text-sm text-[var(--muted)] flex items-center gap-1"><ArrowLeft className="w-4 h-4" /> Marketplace</Link>{me && <CartButton />}</div>
        <h1 className="font-serif font-light text-4xl sm:text-5xl mb-2">Saved items</h1>
        <p className="text-[var(--muted)] mb-10">We'll email you when any of these drop in price.</p>
        {me === null && <EmailGate onDone={reloadMe} />}
        {rows && !rows.length && <p className="font-serif text-2xl text-[var(--muted)]" data-testid="saved-empty">Nothing saved yet. Tap the heart on any listing.</p>}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-10" data-testid="saved-grid">
          {rows?.map((l) => (
            <div key={l.listing_id}>
              <ListingCard l={l} />
              {l.price_dropped && <p className="text-xs text-emerald-700 flex items-center gap-1 mt-1" data-testid={`saved-drop-${l.listing_id}`}><TrendingDown className="w-3.5 h-3.5" /> Price dropped from {money(l.price_at_save)}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
